import DangerModal from './DangerModal';

export default DangerModal;
